<div id="close">
  <div class="modal-toolbar-system-name">
    <img class="logo-size" src="/assets/img/logos/logo-sap-interna.png">
  </div>
  @if (hasClose) {
    <a (click)="close()">
      <mat-icon class="icon-pattern">close</mat-icon>
    </a>
  }
</div>

@if (title) {
  <h4 mat-dialog-title class="modal-toolbar-title primary">{{title}}</h4>
}
